export const LOADING_TAG = 'Loading';
export const SUCCESS_TAG = 'Success';
export const ERROR_TAG = 'Error';
export const NOT_INITIATED_TAG = 'NotInitiated';
//# sourceMappingURL=constants.js.map